import { type Movie } from '@tmdb-graphql-api/schema/types';
import { BackdropSize, ImageSize as imageType } from '#enums/imageSizes.ts';
import { SectionType } from '#enums/mediaTypes.ts';
import { buildImagePath } from '#helpers/buildImagePath.ts';
import { type Config } from '#types.ts';
import { type MovieCollectionData, type PartData } from '../types.ts';

export const formatCollection = (data: MovieCollectionData | null | undefined, { images }: Config): PartData[] =>
  data && data.movie.belongsToCollection
    ? // Need to refactor types here to avoid type assertion
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      (data.movie.belongsToCollection.parts as Movie[]).map(({ backdropPath, id, tagline, title, ...other }) => {
        return {
          ...other,
          id,
          src: buildImagePath(backdropPath, imageType.Backdrop, BackdropSize.SM, images),
          subTitle: tagline,
          title,
          type: SectionType.Movie,
        };
      })
    : [];
